import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";
import { BRAND } from "../data";

const COLS = [
  { title: "Company", links: [["About", "/about"], ["Blog & News", "/blog"], ["Contact", "/contact"], ["Industries", "/industries"]] },
  { title: "Services", links: [["Executive Search", "/services"], ["Permanent Hire", "/services"], ["Contract Staffing", "/services"], ["RPO Solutions", "/services"]] },
  { title: "For You", links: [["Request Staff", "/employers"], ["Find a Job", "/job-seekers"], ["Submit Resume", "/job-seekers"], ["Employers", "/employers"]] },
];

export const Footer = () => (
  <footer className="relative border-t border-slate-800/80 bg-[#0B0F19] pt-16 sm:pt-20 pb-8" data-testid="footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8">
        <div className="lg:col-span-4">
          <Link to="/" className="flex items-center gap-2 mb-5">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-to-br from-amber-400 to-amber-600 text-slate-950 font-accent font-bold text-xl">H</span>
            <span className="font-display font-bold text-xl tracking-tight text-white">{BRAND.name}</span>
          </Link>
          <p className="text-slate-400 text-sm leading-relaxed max-w-xs mb-6">{BRAND.tagline}. Trusted staffing built for long-term success.</p>
          <div className="space-y-2.5 text-sm">
            {BRAND.phones.map((p) => (
              <a key={p} href={`tel:${p.replace(/[^+\d]/g, "")}`} className="flex items-center gap-2.5 text-slate-400 hover:text-amber-400 transition-colors"><Phone className="w-4 h-4 text-amber-500" />{p}</a>
            ))}
            <a href={`mailto:${BRAND.email}`} className="flex items-center gap-2.5 text-slate-400 hover:text-amber-400 transition-colors"><Mail className="w-4 h-4 text-amber-500" />{BRAND.email}</a>
            <p className="flex items-start gap-2.5 text-slate-400"><MapPin className="w-4 h-4 text-amber-500 mt-0.5 shrink-0" />{BRAND.address}</p>
          </div>
        </div>
        <div className="lg:col-span-5 grid grid-cols-2 sm:grid-cols-3 gap-8">
          {COLS.map((col) => (
            <div key={col.title}>
              <h4 className="font-accent text-xs uppercase tracking-[0.2em] text-slate-500 mb-4">{col.title}</h4>
              <ul className="space-y-2.5">
                {col.links.map(([label, to]) => (
                  <li key={label}><Link to={to} className="text-sm text-slate-400 hover:text-white transition-colors">{label}</Link></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="lg:col-span-3">
          <h4 className="font-accent text-xs uppercase tracking-[0.2em] text-slate-500 mb-4">Ready to build?</h4>
          <p className="text-slate-400 text-sm mb-4">Let's discuss the talent that moves your business forward.</p>
          <Link to="/contact" data-testid="footer-cta" className="group inline-flex items-center gap-1.5 px-5 py-2.5 text-sm font-semibold text-slate-950 bg-gradient-to-r from-amber-400 to-amber-500 rounded-lg hover:shadow-lg hover:shadow-amber-500/30 transition-all">
            Contact Us <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </Link>
        </div>
      </div>
      <div className="mt-14 pt-6 border-t border-slate-800/80 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-slate-500 font-mono">© {new Date().getFullYear()} {BRAND.name} LLC · {BRAND.domain}. All rights reserved.</p>
        <div className="flex items-center gap-5 text-xs text-slate-500 font-mono">
          <Link to="/privacy" className="hover:text-amber-400 transition-colors">Privacy</Link>
          <Link to="/terms" className="hover:text-amber-400 transition-colors">Terms</Link>
          <Link to="/cookies" className="hover:text-amber-400 transition-colors">Cookies</Link>
          <a href="/sitemap.xml" className="hover:text-amber-400 transition-colors">Sitemap</a>
        </div>
      </div>
      <p className="mt-4 text-center text-[11px] text-slate-600 font-mono" data-testid="made-by">Made by — Deepak Kumar</p>
    </div>
  </footer>
);
